import { Injectable, InjectionToken } from "@angular/core";
import { Storage } from "@ionic/storage";
import { IKeystoneAuthStorage } from "../../../keystone-http";
import moment from 'moment';

export const StorageService = new InjectionToken('URMET-STORAGE-SERVICE');

@Injectable()
export class AuthenticationStorage implements IKeystoneAuthStorage{
  get ready() {
    return this.storage.ready().then(() => (true))
  }

  constructor(private storage: Storage){
    this.storage.ready().then(() => {
      console.info(`storage ready using ${this.storage.driver}`);
    });
  }
  
  async getToken(): Promise<string> {
    if (await this.ready) {
      return await this.storage.get('urmet-auth-token');
    }
  }
  setToken(token: string) {
    return this.storage.set('urmet-auth-token', token);
  }
  async getTokenExpiration(): Promise<number> {
    if (await this.ready) {
      const expirationString = await this.storage.get('urmet-auth-expiration');
      return +expirationString;
    }
  }
  setTokenExpiration(tokenExpiration: number) {
    return this.storage.set('urmet-auth-expiration', +moment(tokenExpiration));
  }
  async getRefreshToken(): Promise<string> {
    if (await this.ready) {
      return await this.storage.get('urmet-auth-refreshToken');
    }
  }
  setRefreshToken(refreshToken: string) {
    return this.storage.set('urmet-auth-refreshToken', refreshToken);
  }
  async getUid(): Promise<string> {
    if (await this.ready) {
      return await this.storage.get('urmet-auth-uid');
    }
  }
  setUid(uid: string) {
    return this.storage.set('urmet-auth-uid', uid);
  }

  async getIsVerified(): Promise<boolean> {
    if (await this.ready) {
      return await this.storage.get('urmet-auth-verified');
    }
  }
  setIsVerified(value: boolean) {
    return this.storage.set('urmet-auth-verified', value);
  }

  async getFirstLogin(): Promise<boolean> {
    if (await this.ready) {
      return await this.storage.get('urmet-auth-first-login');
    }
  }
  setFirstLogin(value: boolean) {
    return this.storage.set('urmet-auth-first-login', value);
  }

  deleteAll(){
    this.storage.clear();
  }

  // redirectToHome(){
  //  this.getToken().then(token => {
  //    if(!token){
  //     this.navCtrl.push('home');
  //    }
  //   })
  // }
}


// WEBPACK FOOTER //
// ./src/app/core/authentication/authentication-storage.service.ts